export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/brand_style_guides.dc46dce.svg";